import React from 'react'
import { Input } from '../Input'

/**
 * @desc Custom color input.
 */
export const ColorPicker = (props = {}) => {

  props.inputProps.type = 'color'

  return (
    <Input {...props} />
  )
}
